module.exports = __webpack_public_path__ + "img/group.4472849a.svg";